<template>
	<v-app v-scroll.self="onScroll">
		<client-only>
			<v-app-bar
				v-if="$route.query.bar !== '0'"
				extension-height="56"
				app
				elevate-on-scroll
				:elevations="0"
			>
				<v-container :fluid="['xs','sm','md','lg'].includes(breakpoint)">
					<v-row>
						<v-col
							cols="12"
							lg="11"
							xl="10"
							offset-lgs="1"
							class="mx-auto px-0"
						>
							<v-row>
								<v-col class="flex-grow-0 flex-shrink-1 px-lg-0 pl-2 pr-0">
									<n-link
										:to="isPresentationMode ? '' : { name: 'index' }"
										title="หน้าหลัก"
									>
										<img
											src="/images/2.0/LOGO.TB.CO.TH.png"
											alt=""
											class="logo d-inline-block"
											fetchpriority="high"
										>
									</n-link>
								</v-col>
								<v-col class="header-menu flex-grow-1 text-center d-none d-lg-block px-2">
									<nav v-if="!isPresentationMode">
										<ul class="nav">
											<li
												v-for="(link, i) in sitemap"
												:key="`sitemap-${i}`"
											>
												<template v-if="link.resident">
													<v-menu
														attach="header"
														content-class="resident sub-menu-header"
														:close-on-content-click="false"
													>
														<template #activator="{ attrs, on }">
															<a
																:title="link.text"
																:class="{'router-link-exact-active router-link-active': isResidentPage}"
																v-bind="attrs"
																v-on="on"
															>
																{{ link.text }}
																<v-icon
																	color="white"
																	small
																>
																	mdi-chevron-down
																</v-icon>
															</a>
														</template>

														<v-container class="pa-0">
															<v-row no-gutters>
																<v-col
																	xl="11"
																	class="mx-auto px-55 px-sm-100"
																>
																	<v-row no-gutters>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[0].to"
																			>
																				<div class="home-cate-logo home-cate-1" />
																				<div class="text-left ml-3">
																					<!-- <span style="font-size: 1.1rem;">บ้านคุ้มค่า</span><br>
																					ที่อยู่อาศัย 1-3 ล้านบาท -->
																					<span style="font-size: 1.1rem;">ที่อยู่อาศัย</span><br>
																					1-3 ล้านบาท
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[1].to"
																			>
																				<div class="home-cate-logo home-cate-2" />
																				<div class="text-left ml-3">
																					<!-- <span style="font-size: 1.1rem;">บ้านดีมีอนาคต</span><br>
																					ที่อยู่อาศัย 3-10 ล้านบาท -->
																					<span style="font-size: 1.1rem;">ที่อยู่อาศัย</span><br>
																					3-5 ล้านบาท
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[2].to"
																			>
																				<div class="home-cate-logo home-cate-3" />
																				<div class="text-left ml-3">
																					<!-- <span style="font-size: 1.1rem;">บ้านหรูเหนือระดับ</span><br>
																					ที่อยู่อาศัย 10 ล้านขึ้นไป -->
																					<span style="font-size: 1.1rem;">ที่อยู่อาศัย</span><br>
																					5 ล้านขึ้นไป
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[3].to"
																			>
																				<div class="home-cate-logo home-cate-5" />
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">คอนโด</span><br>
																					ที่อยู่อาศัยแนวสูง
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[4].to"
																			>
																				<div class="home-cate-logo home-cate-4" />
																				<div class="text-left ml-3">
																					<!-- <span style="font-size: 1.1rem;">ทรัพย์สร้างเงิน</span><br>
																					อสังหาริมทรัพย์เชิงพาณิชย์ -->
																					<span style="font-size: 1.1rem;">เชิงพาณิชย์</span><br>
																					ทรัพย์เชิงพาณิชย์
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[5].to"
																			>
																				<div class="home-cate-logo home-cate-6" />
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">ที่ดิน</span><br>
																					ทรัพย์เชิงพาณิชย์
																				</div>
																			</v-btn>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-container>
													</v-menu>
												</template>

												<template v-else-if="link.projects">
													<v-menu
														attach="header"
														content-class="resident sub-menu-header"
														:close-on-content-click="false"
													>
														<template #activator="{ attrs, on }">
															<a
																:title="link.text"
																:class="{'router-link-exact-active router-link-active': isProjectsPage}"
																v-bind="attrs"
																v-on="on"
															>
																{{ link.text }}
																<v-icon
																	color="white"
																	small
																>
																	mdi-chevron-down
																</v-icon>
															</a>
														</template>

														<v-container class="pa-0">
															<v-row no-gutters>
																<v-col
																	xl="8"
																	class="mx-auto px-5 px-sm-10"
																>
																	<v-row no-gutters>
																		<v-col cols="3">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				:class="{'current-page': $route.path.indexOf('/singlehome') >= 0}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[0].to"
																			>
																				<div class="home-cate-logo singlehome" />
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">บ้านเดี่ยว</span>
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="3">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				:class="{'current-page': $route.path.indexOf('/townhome') >= 0}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[1].to"
																			>
																				<div class="home-cate-logo townhome" />
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">ทาวน์โฮม</span>
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="3">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				:class="{'current-page': $route.path.indexOf('/condo') >= 0}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[2].to"
																			>
																				<div class="home-cate-logo condo" />
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">คอนโดมิเนียม</span>
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="3">
																			<v-btn
																				height="auto"
																				class="home-cate py-3 px-2"
																				:class="{'current-page': $route.path.indexOf('/shophouse') >= 0}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[3].to"
																			>
																				<div class="home-cate-logo shophouse" />
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">อาคารพาณิชย์</span>
																				</div>
																			</v-btn>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-container>
													</v-menu>
												</template>

												<template v-else-if="link.agents">
													<v-menu
														attach="header"
														content-class="resident sub-menu-header"
														:close-on-content-click="false"
													>
														<template #activator="{ attrs, on }">
															<a
																:title="link.text"
																:class="{'router-link-exact-active router-link-active': isAgentsPage}"
																:target="link.target || ''"
																v-bind="attrs"
																v-on="on"
															>
																{{ link.text }}
																<v-icon
																	color="white"
																	small
																>
																	mdi-chevron-down
																</v-icon>
															</a>
														</template>

														<v-container class="pa-0">
															<v-row no-gutters>
																<v-col
																	xl="8"
																	class="mx-auto px-5 px-sm-10"
																>
																	<v-row no-gutters>
																		<v-col
																			cols="2"
																			offset="4"
																		>
																			<v-btn
																				height="auto"
																				class="home-cate pa-6"
																				:class="{'current-page': $route.path.match(/\/agent/)}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[0].to"
																				:target="link.items[0].target || ''"
																			>
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">{{ link.items[0].text }}</span>
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate pa-6"
																				block
																				tile
																				:to="link.items[1].to"
																				:target="link.items[1].target || ''"
																			>
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">{{ link.items[1].text }}</span>
																				</div>
																			</v-btn>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-container>
													</v-menu>
												</template>

												<template v-else-if="link.articles">
													<v-menu
														attach="header"
														content-class="resident sub-menu-header"
														:close-on-content-click="false"
													>
														<template #activator="{ attrs, on }">
															<a
																:title="link.text"
																:class="{'router-link-exact-active router-link-active': isArticlesPage}"
																v-bind="attrs"
																v-on="on"
															>
																{{ link.text }}
																<v-icon
																	color="white"
																	small
																>
																	mdi-chevron-down
																</v-icon>
															</a>
														</template>

														<v-container class="pa-0">
															<v-row no-gutters>
																<v-col
																	xl="8"
																	class="mx-auto px-5 px-sm-10"
																>
																	<v-row no-gutters>
																		<v-col
																			cols="2"
																			offset="4"
																		>
																			<v-btn
																				height="auto"
																				class="home-cate px-6 py-5"
																				:class="{'current-page': $route.path.match(/\/blog\/review|\/property-review\//)}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[0].to"
																			>
																				<img src="/images/2.0/icon/review-wh.png">
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">รีวิว</span>
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate px-6 py-5"
																				:class="{'current-page': $route.path.match(/\/blog\/tips|\/article\/tips\//)}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[1].to"
																			>
																				<img src="/images/2.0/icon/knowledge-wh.png">
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">สาระน่ารู้</span>
																				</div>
																			</v-btn>
																		</v-col>
																		<v-col cols="2">
																			<v-btn
																				height="auto"
																				class="home-cate px-6 py-5"
																				:class="{'current-page': $route.path.match(/\/blog\/home\-knowledge|\/article\/home\-knowledge\//)}"
																				block
																				tile
																				active-class="current-page"
																				:to="link.items[2].to"
																			>
																				<img src="/images/2.0/icon/knowledge-wh.png">
																				<div class="text-left ml-3">
																					<span style="font-size: 1.1rem;">ความรู้เรื่องบ้าน</span>
																				</div>
																			</v-btn>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-container>
													</v-menu>
												</template>

												<template v-else-if="link.items">
													<v-menu
														content-class="sub-menu-header"
														offset-y
													>
														<template #activator="{ attrs, on }">
															<a
																:title="link.text"
																:target="link.target || ''"
																v-bind="attrs"
																v-on="on"
															>
																{{ link.text }}
																<v-icon
																	color="white"
																	small
																>
																	mdi-chevron-down
																</v-icon>
															</a>
														</template>

														<v-list>
															<v-list-item
																v-for="(sub, j) in link.items"
																:key="`sitemap-${i}-${j}`"
																link
															>
																<n-link
																	:to="sub.to"
																	:title="sub.text"
																	:event="sub.event || 'click'"
																	:target="sub.target || ''"
																	class="py-3 flex-grow-1"
																>
																	{{ sub.text }}
																</n-link>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>

												<n-link
													v-else
													:to="link.to"
													:title="link.text"
													:event="link.event || 'click'"
													:target="link.target || ''"
												>
													{{ link.text }}
												</n-link>
											</li>
										</ul>
									</nav>
								</v-col>
								<v-col class="flex-grow-0 flex-shrink-1 ml-auto px-lg-0 pl-0 pr-2 d-flex justify-end align-center">
									<client-only>
										<div class="d-inline-block iconSearch">
											<searchForm
												v-if="!isPresentationMode"
												ref="mobileSearchComponent"
												:params="$route.query"
											/>
										</div>
									</client-only>
									<div class="favorite">
										<favoriteProps v-if="!isPresentationMode" />
									</div>
									<requirementForm v-if="breakpoint !== 'xs' && !isPresentationMode" />
									<v-app-bar-nav-icon
										v-if="!isPresentationMode"
										class="d-lg-none"
										color="white"
										aria-label="Toggle main menu"
										@click.stop="toggleMenu"
									/>
									<v-menu
										v-model="menuActive"
										attach="header"
										nudge-right="0"
										min-width="100%"
										:nudge-bottom="menuY"
										:max-height="menuHeight"
										:close-on-content-click="false"
									>
										<v-list
											class="mobile-menu pa-3"
											tile
											expands
										>
											<template v-for="(link, i) in sitemap">
												<v-list-item
													v-if="!link.items"
													:key="`sitemap-mobile-${i}`"
													link
													@click="hideMenu"
												>
													<n-link
														:to="link.to"
														:title="link.text"
														:event="link.event || 'click'"
														class="py-3 flex-grow-1"
													>
														<b>{{ link.text }}</b>
													</n-link>
												</v-list-item>

												<v-list-group
													v-else
													:key="`sitemap-mobile-sub-${i}`"
													no-action
												>
													<template #activator>
														<v-list-item-title><b>{{ link.text }}</b></v-list-item-title>
													</template>
													<template #appendIcon>
														<v-icon color="rgb(237,28,36)">
															mdi-chevron-right
														</v-icon>
													</template>

													<v-list-item
														v-for="(sub, j) in link.items"
														:key="`sitemap-mobile-sub-${i}-${j}`"
														class="pl-10"
														link
														@click="hideMenu"
													>
														<n-link
															:to="sub.to"
															:title="sub.text"
															:event="sub.event || 'click'"
															class="py-3 flex-grow-1"
														>
															<b>{{ sub.text }}</b>
														</n-link>
													</v-list-item>
												</v-list-group>
											</template>
										</v-list>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>

				<template
					v-if="breakpoint === 'xs'"
					#extension
				>
					<requirementForm v-if="!isPresentationMode" />
				</template>
			</v-app-bar>
		</client-only>
		<!-- Appbar -->

		<!-- Layout -->
		<div ref="topPage" />
		<nuxt
			keep-alive
			:keep-alive-props="{ include: keepAlivePages }"
			:class="isMobile ? 'mobile' : '' + (showExtendfilter ? 'hasFilter' : '')"
		/>

		<div
			v-if="!isPresentationMode && $route.query.chat !== '0'"
			class="widget-shortcut"
		>
			<v-speed-dial
				v-model="chatChoice"
				direction="top"
				transition="slide-y-reverse-transition"
			>
				<template v-slot:activator>
					<v-btn
						v-model="chatChoice"
						color="#c20000"
						height="auto"
						class="pa-2"
						dark
						tile
					>
						<div class="d-flex flex-column">
							<v-icon v-if="chatChoice">
								mdi-close
							</v-icon>
							<v-icon v-else>
								mdi-chat-processing-outline
							</v-icon>
							<b>CHAT</b>
						</div>
					</v-btn>
				</template>
				<v-btn
					href="https://line.me/ti/p/~@thebestproperty"
					target="_blank"
					alt="ติดต่อ The Best Property ทาง Line @thebestproperty"
					title="ติดต่อ The Best Property ทาง Line @thebestproperty"
					color="rgba(0,0,0,0.3)"
					height="auto"
					class="ma-0 pa-2"
					dark
					tile
				>
					<img src="/images/2.0/icon/contact/line-green.png">
				</v-btn>
				<v-btn
					href="https://m.me/thebestpropertyhome"
					target="_blank"
					alt="สนทนากับ The Best Property"
					title="สนทนากับ The Best Property"
					color="rgba(0,0,0,0.3)"
					height="auto"
					class="ma-0 pa-2"
					dark
					tile
				>
					<img src="/images/2.0/icon/contact/messenger-blue.png">
				</v-btn>
			</v-speed-dial>
			<v-btn
				v-model="chatChoice"
				color="#000"
				height="auto"
				class="pa-2"
				dark
				tile
				@click="$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'start' })"
			>
				<div class="d-flex flex-column">
					<v-icon>
						mdi-chevron-double-up
					</v-icon>
					<b>TOP</b>
				</div>
			</v-btn>
		</div>

		<footer v-if="hasFooter && $route.query.footer !== '0'">
			<v-expansion-panels
				class="d-md-none"
				style="border-radius: 0;"
				focusable
				accordion
				dark
			>
				<v-expansion-panel
					v-for="(col, i) in scLinks"
					:key="`col-${i}`"
				>
					<v-expansion-panel-header color="black">
						{{ col.name }}
					</v-expansion-panel-header>
					<v-expansion-panel-content class="gradient-grey">
						<template #default>
							<ul class="pt-4">
								<li
									v-for="link in col.links"
									:key="link.text"
								>
									<n-link
										:to="link.to"
										:title="link.text"
									>
										{{ link.text }}
									</n-link>
								</li>
							</ul>
						</template>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<div
				v-if="!isPresentationMode"
				class="d-none d-md-block white--text"
				style="background-color: black;"
			>
				<v-container
					:fluid="['xs','sm','md'].includes(breakpoint)"
					class="py-0"
				>
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row no-gutters>
								<v-col
									v-for="(col, i) in scLinks"
									:key="`col-${i}`"
									cols="3"
									class="hover-red px-1 py-5 text-center"
								>
									{{ col.name }}
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div
				v-if="!isPresentationMode"
				class="gradient-grey d-none d-md-block white--text py-6"
			>
				<v-container :fluid="['xs','sm','md'].includes(breakpoint)">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
							class="listFooter"
						>
							<v-row no-gutters>
								<v-col
									v-for="(col, i) in scLinks"
									:key="`col-${i}`"
									cols="3"
									class="px-1"
								>
									<ul>
										<li
											v-for="link in col.links"
											:key="link.text"
										>
											<n-link
												:to="link.to"
												:title="link.text"
												class="hover-red"
											>
												{{ link.text }}
											</n-link>
										</li>
									</ul>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div class="gradient-red white--text">
				<v-container :fluid="['xs','sm','md'].includes(breakpoint)">
					<v-row
						no-gutters
					>
						<v-col
							xl="8"
							offset-xl="2"
							class="footer"
						>
							<v-row no-gutters>
								<v-col
									cols="12"
									md="3"
									class="flex-grow-0 py-5"
								>
									<n-link
										:to="isPresentationMode ? '' : { name: 'index' }"
										title="หน้าหลัก"
									>
										<img
											src="/images/2.0/LOGO.TB.CO.TH.png"
											alt=""
											class="mb-2"
											fetchpriority="high"
										>
									</n-link>
									<p class="mb-5 font-weight-bold">
										ผู้นำด้านการซื้อขาย<br>
										อสังหาริมทรัพย์ทุกประเภท
									</p>
								</v-col>
								<v-col
									cols="12"
									md="5"
									class="flex-grow-1 py-5"
								>
									<h3>บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด</h3>
									<p class="mb-5">
										สำนักงานใหญ่ เลขที่ 40/88 ซอยมัณฑนา หมู่ 5 ตำบลบางเมือง<br>
										อำเภอเมือง จังหวัดสมุทรปราการ
									</p>
									<h3>
										<a
											href="tel:020474282"
											title="ติดต่อ The Best Property ทางโทรศัพท์ โทร 02-047-4282"
										>
											<v-icon>mdi-phone</v-icon>
											02-047-4282
										</a>
									</h3>
									<div class="mt-2">
										<a
											href="https://www.facebook.com/thebestpropertyhome"
											title="ติดตาม The Best Property  บนเฟสบุ๊ค"
											target="_blank"
										>
											<img
												src="/images/icon/facebook.png"
												alt="facebook"
												width="22"
											>
										</a>
										<a
											href="https://line.me/ti/p/~@thebestproperty"
											title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
											target="_blank"
										>
											<img
												src="/images/icon/line.png"
												alt="line"
												width="22"
												class="ml-2"
											>
										</a>
										<a
											href="https://m.me/thebestpropertyhome"
											title="สนทนากับ The Best Property"
											target="_blank"
										>
											<img
												src="/images/icon/messenger.png"
												alt="messenger"
												width="22"
												class="ml-2"
											>
										</a>
									</div>
								</v-col>
								<v-col
									v-if="!isPresentationMode"
									cols="12"
									md="4"
									class="flex-grow-0 py-5"
								>
									<h4 class="mb-2">
										แผนผังเว็บไซต์
									</h4>
									<v-row no-gutters>
										<v-col cols="6">
											<n-link
												to="/"
												title="หน้าหลัก"
											>
												หน้าหลัก
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/service"
												title="บริการของเรา"
											>
												บริการของเรา
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/search?tx=BUY&market=REST"
												title="ขาย"
											>
												ขาย
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/portfolio"
												title="ผลงานของเรา"
											>
												ผลงานของเรา
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/search?tx=RENT&market=REST"
												title="เช่า"
											>
												เช่า
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/blog/review"
												title="รีวิว"
											>
												รีวิว
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/agent"
												title="ค้นหาตัวแทน"
											>
												ค้นหาตัวแทน
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/blog/tips"
												title="สาระน่ารู้"
											>
												สาระน่ารู้
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/privacy-policy"
												title="Privacy Policy"
											>
												Privacy Policy
											</n-link>
										</v-col>
										<v-col cols="6">
											<n-link
												to="/terms-and-conditions"
												title="Terms and Conditions"
											>
												Terms and Conditions
											</n-link>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
					<div class="text-center">
						<p class="mb-0">
							สงวนลิขสิทธิ์ พ.ศ. {{ new Date().getFullYear() + 543 }} บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด
							<small class="ml-auto grey--text">(v.{{ version }})</small>
						</p>
					</div>
				</v-container>
			</div>

			<client-only>
				<cookie-law
					v-if="$route.query.cookie !== '0' && !isMobileWebView"
					theme="blood-orange"
					button-text="ยอมรับ"
					message="เว็บไซต์ของ THE BEST PROPERTY AGENT ใช้คุกกี้เพื่อให้เว็บไซต์ทำงานได้อย่างถูกต้อง และช่วยปรับปรุงประสบการณ์การใช้งานของคุณเท่านั้น เราไม่ใช้คุกกี้เพื่อเก็บข้อมูลส่วนบุคคล หรือเพื่อติดตามการใช้งานของคุณในเชิงโฆษณา การกดปุ่ม “ยอมรับ” หมายถึงคุณยอมรับการใช้งานคุกกี้พื้นฐานที่จำเป็นต่อการทำงานของเว็บไซต์เท่านั้น"
				/>
			</client-only>
		</footer>
	</v-app>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import favoriteProps from '~/components/favorite-props'
import searchForm from '~/components/2.0/search-form'
import requirementForm from '~/components/2.0/requirement-form'

import {version} from '../package.json'

export default {
	components: {
		favoriteProps,
		searchForm,
		requirementForm,
		CookieLaw: () => process.client ? import('vue-cookie-law') : null
	},

	data() {
		return {
			version,
			menuActive: false,
			menuY: 56,
			menuHeight: 'calc(100vh - 56px)',

			chatChoice: false,

			miniVariant: false,
			invertedScroll: true,
			showMiniFilterLabel: false,
			keepAlivePages: [
				'INDEX',
				'LIST',
				'MAP',
				'AGENT',
				'PORTFOLIO',
				'Samutprakan'
			],

			sitemap: [
				{ to: { name: 'index' }, text: 'หน้าหลัก' },
				{
					to: '',
					text: 'รวมที่อยู่อาศัย',
					resident: true,
					items: [
						// { to: '/value', text: 'บ้านคุ้มค่า' },
						// { to: '/promising', text: 'บ้านดีมีอนาคต' },
						// { to: '/luxury', text: 'บ้านหรูเหนือระดับ' },
						// { to: '/commercial', text: 'ทรัพย์สร้างเงิน' },
						{ to: '/value', text: 'ที่อยู่อาศัย 1-3 ล้านบาท' },
						{ to: '/promising', text: 'ที่อยู่อาศัย 3-5 ล้านบาท' },
						{ to: '/luxury', text: 'ที่อยู่อาศัย 5 ล้านขึ้นไป' },
						{ to: '/home-condo', text: 'คอนโด' },
						{ to: '/commercial', text: 'เชิงพาณิชย์' },
						{ to: '/land', text: 'ที่ดิน' },
					]
				},
				{
					to: '',
					text: 'รวมโครงการ',
					projects: true,
					items: [
						{ to: '/singlehome', text: 'บ้านเดี่ยว' },
						{ to: '/townhome', text: 'ทาวน์โฮม' },
						{ to: '/condo', text: 'คอนโดมิเนียม' },
						{ to: '/shophouse', text: 'อาคารพาณิชย์' },
					]
				},
				{ to: { name: 'service' }, text: 'บริการของเรา' },
				{ to: '/portfolio', text: 'ผลงานของเรา' },
				// { to: '/agent', text: 'ค้นหาตัวแทน' },
				{
					to: '',
					text: 'ตัวแทนของเรา',
					agents: true,
					items: [
						{ to: '/agent', text: 'ค้นหาตัวแทน' },
						{ to: '/guest-register?ref=1002', text: 'สมัครตัวแทน', target: '_blank' },
					]
				},
				{
					to: '/blog',
					text: 'บทความ',
					articles: true,
					items: [
						{ to: '/blog/review', text: 'รีวิว' },
						{ to: '/blog/tips', text: 'สาระน่ารู้' },
						{ to: '/blog/home-knowledge', text: 'ความรู้เรื่องบ้าน' },
					]
				},
				{ to: '/contact-us', text: 'ติดต่อเรา' },
			],

			scLinks: [
				{
					name: 'ประกาศขายบ้านในกรุงเทพฯ',
					links: [
						{ to: '/bangkok/singlehome', text: 'ขายบ้านเดี่ยว กรุงเทพฯ' }, // search?province=1&tx=BUY&market_selected=HOME
						{ to: '/bangkok/townhome', text: 'ขายทาวน์เฮ้าส์ กรุงเทพฯ' }, // search?province=1&tx=BUY&market_selected=TOWNHOUSE
						{ to: '/bangkok/condo', text: 'ขายคอนโด กรุงเทพฯ' }, // search?province=1&tx=BUY&market_selected=CONDO
						{ to: '/search?province=1&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน กรุงเทพฯ' },
						{ to: '/search?province=1&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว กรุงเทพฯ เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=1&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ กรุงเทพฯ เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=1&market_selected=CONDO&tx=BUY&minprice=1000000&order=min-price', text: 'ขายคอนโด กรุงเทพฯ เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=1&tx=BUY&market=REST', text: 'ขายบ้านมือสองกรุงเทพฯ โปรโมชั่นพิเศษ' },
					]
				},
				{
					name: 'ประกาศขายบ้านในสมุทรปราการ',
					links: [
						{ to: '/samut-prakan/singlehome', text: 'ขายบ้านเดี่ยว สมุทรปราการ' },
						{ to: '/samut-prakan/townhome', text: 'ขายทาวน์เฮ้าส์ สมุทรปราการ' },
						{ to: '/samut-prakan/condo', text: 'ขายคอนโด สมุทรปราการ' },
						{ to: '/search?province=2&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน สมุทรปราการ' },
						{ to: '/search?province=2&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว สมุทรปราการ เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=2&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ สมุทรปราการ เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=2&market_selected=CONDO&minprice=1000000&tx=BUY&order=min-price', text: 'ขายคอนโด สมุทรปราการ เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=2&tx=BUY&market=REST', text: 'ขายบ้านมือสองสมุทรปราการ โปรโมชั่นพิเศษ' },
					]
				},
				{
					name: 'ประกาศขายบ้านในนนทบุรี',
					links: [
						{ to: '/nonthaburi/singlehome', text: 'ขายบ้านเดี่ยว นนทบุรี' }, // search?province=3&tx=BUY&market_selected=HOME
						{ to: '/nonthaburi/townhome', text: 'ขายทาวน์เฮ้าส์ นนทบุรี' }, // search?province=3&tx=BUY&market_selected=TOWNHOUSE
						{ to: '/nonthaburi/condo', text: 'ขายคอนโด นนทบุรี' }, // search?province=3&tx=BUY&market_selected=CONDO
						{ to: '/search?province=3&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน นนทบุรี' },
						{ to: '/search?province=3&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว นนทบุรี เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=3&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ นนทบุรี เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=3&market_selected=CONDO&minprice=1000000&tx=BUY&order=min-price', text: 'ขายคอนโด นนทบุรี เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=3&tx=BUY&market=REST', text: 'ขายบ้านมือสองนนทบุรี โปรโมชั่นพิเศษ' },
					]
				},
				{
					name: 'ประกาศขายบ้านในชลบุรี',
					links: [
						{ to: '/chonburi/singlehome', text: 'ขายบ้านเดี่ยว ชลบุรี' }, // search?province=11&tx=BUY&market_selected=HOME
						{ to: '/chonburi/townhome', text: 'ขายทาวน์เฮ้าส์ ชลบุรี' }, // search?province=11&tx=BUY&market_selected=TOWNHOUSE
						{ to: '/chonburi/condo', text: 'ขายคอนโด ชลบุรี' }, // search?province=11&tx=BUY&market_selected=CONDO
						{ to: '/search?province=11&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน ชลบุรี' },
						{ to: '/search?province=11&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว ชลบุรี เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=11&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ ชลบุรี เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=11&market_selected=CONDO&minprice=1000000&tx=BUY&order=min-price', text: 'ขายคอนโด ชลบุรี เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=11&tx=BUY&market=REST', text: 'ขายบ้านมือสองชลบุรี โปรโมชั่นพิเศษ' },
					]
				}
			]
		}
	},

	computed: {
		...mapGetters(['isMobile', 'hasFooter', 'latestUpdated', 'newProps']),

		breakpoint () {
			return this.$vuetify.breakpoint.name
		},

		showExtendfilter () {
			return ['/', '/search', '/promotion'].includes(this.$route.path) || ['samut-prakan'].includes(this.$route.name)
		},

		isPresentationMode () {
			return this.$route.path.indexOf('/property-presentation') === 0
		},

		isResidentPage () {
			return ['/value', '/promising', '/luxury', '/commercial'].includes(this.$route.path)
		},

		isProjectsPage () {
			return [
				'category-hub-singlehome', 'category-hub-townhome', 'category-hub-condo', 'category-hub-shophouse',
				'samut-prakan-hub', 'bangkok-hub', 'nonthaburi-hub', 'chonburi-hub',
				'samut-prakan', 'bangkok', 'nonthaburi', 'chonburi',
			].includes(this.$route.name)
		},

		isAgentsPage () {
			return [
				'agent', 'agent-detail'
			].includes(this.$route.name)
		},

		isArticlesPage () {
			return [
				'blog', 'blog-review', 'blog-tips', 'article'
			].includes(this.$route.name)
		},

		isMobileWebView () {
			return !process.client || window.flutter_inappwebview
		}
	},

	watch: {

	},

	created() {
		if (process.client) {
			// if (this.$route.query.log !== '1') {
			// 	// console.error = function() {}
			// 	window['console']['error'] = function() {}
			// }

			// Inspect user device for first access
			this.deviceInspect()
		}
	},

	mounted() {
		window.windowNavigate = false
		window.addEventListener('popstate', this.backHandler, false) //backbutton
	},

	beforeDestroy () {
		window.removeEventListener('popstate', this.backHandler) //backbutton
	},

	methods: {
		...mapMutations({
			deviceInspect: 'deviceInspect'
		}),

		backHandler () {
			window.windowNavigate = true
		},

		toggleMenu (event) {
			event.preventDefault()
			let rect = document.querySelector('.v-toolbar__content').getBoundingClientRect()
			this.menuActive = false
			this.menuY = rect.bottom
			this.menuHeight = document.defaultView.screen.height - rect.bottom
			this.$nextTick(() => {
				this.menuActive = true
			})
		},

		hideMenu (event) {
			event.preventDefault()
			this.$nextTick(() => {
				this.menuActive = false
			})
		},

		onScroll (e) {
			if (this.showExtendfilter) {
				if (e.target.scrollingElement.scrollTop > 220) {
					this.$nextTick(() => {
						this.showMiniFilterLabel = true
					})
				} else {
					this.$nextTick(() => {
						this.showMiniFilterLabel = false
					})
				}
			}
		}
	}
}
</script>
<style lang="scss">
@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-BlackItalic.eot');
	src: local('ARS Maquette Pro Black Italic'), local('ARSMaquettePro-BlackItalic'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BlackItalic.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BlackItalic.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BlackItalic.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BlackItalic.ttf') format('truetype');
	font-weight: 900;
	font-style: italic;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-Regular.eot');
	src: local('ARS Maquette Pro Regular'), local('ARSMaquettePro-Regular'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Regular.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Regular.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Regular.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Regular.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-LightItalic.eot');
	src: local('ARS Maquette Pro Light Italic'), local('ARSMaquettePro-LightItalic'),
			url('~assets/fonts/ARSM/ARSMaquettePro-LightItalic.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-LightItalic.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-LightItalic.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-LightItalic.ttf') format('truetype');
	font-weight: 300;
	font-style: italic;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-Bold.eot');
	src: local('ARS Maquette Pro Bold'), local('ARSMaquettePro-Bold'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Bold.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Bold.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Bold.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Bold.ttf') format('truetype');
	font-weight: bold;
	font-style: normal;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-Italic.eot');
	src: local('ARS Maquette Pro Italic'), local('ARSMaquettePro-Italic'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Italic.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Italic.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Italic.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Italic.ttf') format('truetype');
	font-weight: normal;
	font-style: italic;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-MediumItalic.eot');
	src: local('ARS Maquette Pro Medium Italic'), local('ARSMaquettePro-MediumItalic'),
			url('~assets/fonts/ARSM/ARSMaquettePro-MediumItalic.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-MediumItalic.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-MediumItalic.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-MediumItalic.ttf') format('truetype');
	font-weight: 500;
	font-style: italic;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-Medium.eot');
	src: local('ARS Maquette Pro Medium'), local('ARSMaquettePro-Medium'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Medium.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Medium.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Medium.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Medium.ttf') format('truetype');
	font-weight: 500;
	font-style: normal;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-Light.eot');
	src: local('ARS Maquette Pro Light'), local('ARSMaquettePro-Light'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Light.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Light.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Light.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Light.ttf') format('truetype');
	font-weight: 300;
	font-style: normal;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-BoldItalic.eot');
	src: local('ARS Maquette Pro Bold Italic'), local('ARSMaquettePro-BoldItalic'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BoldItalic.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BoldItalic.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BoldItalic.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-BoldItalic.ttf') format('truetype');
	font-weight: bold;
	font-style: italic;
	font-display: swap;
}

@font-face {
	font-family: 'ARS Maquette Pro';
	src: url('~assets/fonts/ARSM/ARSMaquettePro-Black.eot');
	src: local('ARS Maquette Pro Black'), local('ARSMaquettePro-Black'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Black.eot?#iefix') format('embedded-opentype'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Black.woff2') format('woff2'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Black.woff') format('woff'),
			url('~assets/fonts/ARSM/ARSMaquettePro-Black.ttf') format('truetype');
	font-weight: 900;
	font-style: normal;
	font-display: swap;
}

.v-application {
	.red--text {
		color: #ed1c24 !important;
		caret-color: #ed1c24 !important;
	}
	.grey--text {
		color: #919191 !important;
		caret-color: #919191 !important;
	}
}
.btn-red-gradient {
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(233,41,48,1) 50%, rgba(201,37,44,1) 100%);
}
.btn-black-gradient {
	background: rgb(32,32,32);
	background: linear-gradient(180deg, rgba(103,103,103,1) 0%, rgba(51,51,51,1) 50%, rgba(32,32,32,1) 100%);
}

.triangle-botleft:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 10px;
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(233,41,48,1) 50%, rgba(201,37,44,1) 100%);
    clip-path: polygon(-1px 0, 0 0, 100% 100%, -1px 100%);
	}
</style>

<style lang="scss" scoped>
	header::v-deep {

		.logo {
			height: 45px;
		}
		.nav li a {
			padding: 10px 8px;

			@media (max-width: 1450px) {
				& {
					padding: 10px 4px;
				}
			}
			@media (max-width: 1380px) {
				& {
					padding: 10px 1px;
				}
			}
			@media (max-width: 1330px) {
				& {
					padding: 10px 0;
					margin: 0 4px;
				}
			}
		}
		.iconSearch, .favorite {
			margin-right: 8px;
		}
		.v-toolbar__extension {
			padding: 0;
		}
	}
	.header-menu {
		white-space: nowrap;
    overflow: hidden;
		.router-link-exact-active.router-link-active {
			border-bottom: solid 3px #000;
		}
	}
	main {
		// background: #e5e5e5;
		background: #fff;
	}
	.v-menu__content {
		border-radius: 0;
	}
	.mobile-menu {
		border-radius: 0;
		border-bottom: solid rgb(237,28,36);

		a {
			text-decoration: none;
			color: #000;
		}
	}
	footer {
		a {
			color: #fff;
			text-decoration: none;
		}
		ul {
			padding-left: 15px;

			li {
				padding: 4px 0;

				&::marker { color: red; }
			}
		}
		.gradient-grey {
			background: rgb(81,81,81);
			background: linear-gradient(180deg, rgba(81,81,81,1) 0%, rgba(62,62,62,1) 50%, rgba(57,57,57,1) 100%);
		}
		.gradient-red, .hover-red:hover {
			background: rgb(213,36,42);
			background: linear-gradient(180deg, rgba(213,36,42,1) 0%, rgba(187,30,37,1) 100%);
		}
		.footer {
			i { color: #fff; font-size: 16px; }
			a:hover * {
				color: #000 !important;
			}
		}
	}
  .sideMenu::v-deep {
		.v-list-group__header {
			min-height: 40px;
			font-size: 0.875rem;
		}
    a { text-decoration: none; color: #000; margin: 1px 0 2px 0; }
	}
	.sub-menu-header {
		box-shadow: unset;

		&.resident {
			background-color: #000;
			min-width: 100vw !important;
			top: 100% !important;
			left: 0 !important;

			.home-cate {
				background-color: #000 !important;
				color: #fff;
				// justify-content: flex-start !important;

				&::before {
					opacity: 0;
				}
				.home-cate-logo {
					width: 52px;
					height: 52px;
					background-size: contain;
					background-repeat: no-repeat;
					background-position: center;

					&.home-cate-1 { background-image: url(/images/2.0/icon/home-1.png); }
					&.home-cate-2 { background-image: url(/images/2.0/icon/home-2.png); }
					&.home-cate-3 { background-image: url(/images/2.0/icon/home-3.png); }
					&.home-cate-4 { background-image: url(/images/2.0/icon/home-4.png); }
					&.home-cate-5 { background-image: url(/images/2.0/icon/home-5.png); }
					&.home-cate-6 { background-image: url(/images/2.0/icon/home-6.png); }

					&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
					&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
					&.condo { background-image: url(/images/2.0/icon/condo.png); }
					&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
				}

				&:hover, &.current-page {
					background-color: #c20000 !important;

					& .home-cate-logo {
						&.home-cate-1 { background-image: url(/images/2.0/icon/home-1_wh.png); }
						&.home-cate-2 { background-image: url(/images/2.0/icon/home-2_wh.png); }
						&.home-cate-3 { background-image: url(/images/2.0/icon/home-3_wh.png); }
						&.home-cate-4 { background-image: url(/images/2.0/icon/home-4_wh.png); }
						&.home-cate-5 { background-image: url(/images/2.0/icon/home-5_wh.png); }
						&.home-cate-6 { background-image: url(/images/2.0/icon/home-6_wh.png); }

						&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
						&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
						&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
						&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
					}
				}
			}
		}
		.v-list.v-sheet {
			background-color: #c20000;

			a {
				text-decoration: none;
				color: #fff;
			}
		}
	}
	.search {
		background: transparent;
		border-radius: 0;
		padding: 0;
	}
	.miniFilter::v-deep {
		> .v-toolbar__extension {
			padding: 4px;

			> .inputSelect > div:not(:last-child) {
				max-width: 30%;
			}
		}
	}
	.widget-shortcut::v-deep {
		position: fixed;
		//top: 50%;
		bottom: 30px;
		right: 0;
		z-index: 9;
		.v-speed-dial__list {
			padding: 0 !important;
		}
	}
</style>
